import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import User from "../../../classes/User";

export default {
  routes: [
    {
      name: "users",
      path: "users/:filter?",
      meta: {
        auth: () => User.canBeViewedBy(store.state.main.user),
        icon: (route) =>
          route.params.filter === "customers"
            ? "customer"
            : route.params.filter === "disabled"
            ? "user_disable"
            : "user",
        title: i18n.global.tc("User", 100),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/admin/Users"),
    },
  ],

  dialogs: [
    {
      name: "user-new",
      path: "/admin/users/employees/new",
      meta: {
        auth: () => User.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/UserEdit"),
    },
    {
      name: "customer-new",
      path: "/admin/users/customers/new",
      meta: {
        auth: () => User.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/UserEdit"),
    },
    {
      name: "user-edit",
      path: "/admin/users/employees/:userID/edit",
      meta: {
        auth: () => User.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/UserEdit"),
    },
    {
      name: "customer-edit",
      path: "/admin/users/customers/:userID/edit",
      meta: {
        auth: () => User.canBeCreatedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/UserEdit"),
    },
    {
      name: "user-view",
      path: "/admin/users/employees/:userID/view/:section",
      meta: {
        auth: () => User.canBeViewedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/UserView"),
    },
    {
      name: "customer-view",
      path: "/admin/users/customers/:userID/view/:section",
      meta: {
        auth: () => User.canBeViewedBy(store.state.main.user),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/UserView"),
    },
  ],
};
